import React, { useState } from "react";
// External
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
// Icons
import CloseIcon from "@mui/icons-material/Close";
// Internal
import useStyles from "./useStyles";
var CoachingLink = function (_a) {
    var coachingTipHeader = _a.coachingTipHeader, children = _a.children, title = _a.title;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var onClick = function (_a) {
        var currentTarget = _a.currentTarget;
        if (!open) {
            if (window.analytics)
                window.analytics.track("Coaching Tips viewed", title);
        }
        else if (window.analytics)
            window.analytics.track("Coaching Tips closed", title);
        setOpen(!open);
        setAnchorEl(currentTarget);
    };
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: classes.button, color: "primary", onClick: onClick, variant: "outlined" }, "Coaching Tips"),
        React.createElement(Popper, { anchorEl: anchorEl, open: open, placement: "bottom-end", className: classes.popper },
            React.createElement(Paper, { className: classes.paper, elevation: 3 },
                React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between" },
                    React.createElement(Typography, { variant: "h5" }, coachingTipHeader),
                    React.createElement(IconButton, { onClick: onClick, size: "small" },
                        React.createElement(CloseIcon, null))),
                React.createElement(Box, { maxHeight: "70vh", overflow: "auto" }, children)))));
};
export default CoachingLink;
//# sourceMappingURL=index.js.map